import { render } from "./all_practice_results.vue?vue&type=template&id=d49fa760"
import script from "./all_practice_results.vue?vue&type=script&lang=js"
export * from "./all_practice_results.vue?vue&type=script&lang=js"

import exportComponent from "D:\\_FEproject\\aplikovanainformatika.sk\\zoneai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__